import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VImg,{staticClass:"ls-image",style:(_vm.content.rounded ? 'width:150px; height:150px; border-radius: 150px;': ''),attrs:{"max-height":_vm.content.max_height,"max-width":_vm.content.max_width,"min-height":_vm.content.min_height,"min-width":_vm.content.min_width,"src":_vm.content.value,"lazy-src":_vm.content.value,"contain":_vm.content.contain},on:{"click":function($event){return _vm.setImageBlock(_vm.content)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }